export default __webpack_public_path__ + "static/media/appstore-badge.7478969a.svg";